import type { HelpFile } from '../../types/help'
import { SyncRunsTabTestIds } from '../../../testids/SyncRunsTabTestIds'

export const syncRunsTabHelp: HelpFile = {
  docPage: '/docs/connectors/inbound',
  texts: {
    [SyncRunsTabTestIds.syncRunsCard]:
      'Aktuelle Synchronisationsläufe für diesen eingehenden Konnektor — Start- und Endzeiten, Datensatzzahlen und Ergebnisse.',
    [SyncRunsTabTestIds.syncRunDetail]:
      'Detailansicht eines einzelnen Synchronisationslaufs — Phasenzeitstempel, Datensatzzahlen pro Operation und Fehler.',
    [SyncRunsTabTestIds.cardTitleSyncRecords]:
      'Pro-Datensatz-Ergebnisse, die während des ausgewählten Synchronisationslaufs erfasst wurden.',
    [SyncRunsTabTestIds.cardTitleSyncErrorLogs]:
      'Während dieses Synchronisationslaufs erfasste Fehler — jede Zeile verlinkt auf den vollständigen Fehlerlog-Eintrag.',
    [SyncRunsTabTestIds.colErrorLogId]:
      'Bezeichner des Fehlerlog-Eintrags — klicken, um den vollständigen Log zu öffnen.',
    [SyncRunsTabTestIds.colErrorLogCreatedAt]:
      'Zeitpunkt der Fehlererfassung.',
    [SyncRunsTabTestIds.syncRunsEmpty]:
      'Wird angezeigt, wenn für diesen Konnektor noch keine Synchronisationsläufe aufgezeichnet wurden.',
    [SyncRunsTabTestIds.syncRunsLoading]: null,
    [SyncRunsTabTestIds.colSyncRunType]:
      'Synchronisationstyp — vollständig oder Vorschau (oder der Rohwert für historische Zeilen).',
    [SyncRunsTabTestIds.colSyncRunStatus]:
      'Ergebnis des Synchronisationslaufs (erfolgreich, fehlgeschlagen, pausiert, ...).',
    [SyncRunsTabTestIds.colSyncRunStarted]:
      'Wann der Synchronisationslauf begonnen hat.',
    [SyncRunsTabTestIds.colSyncRunDuration]:
      'Gesamtdauer des Synchronisationslaufs (Echtzeit).',
    [SyncRunsTabTestIds.colSyncRunCreated]:
      'Anzahl der während des Synchronisationslaufs erstellten Datensätze.',
    [SyncRunsTabTestIds.colSyncRunUpdated]:
      'Anzahl der während des Synchronisationslaufs aktualisierten Datensätze.',
    [SyncRunsTabTestIds.colSyncRunSkipped]:
      'Anzahl der während des Synchronisationslaufs übersprungenen Datensätze.',
    [SyncRunsTabTestIds.colSyncRunErrored]:
      'Anzahl der während des Synchronisationslaufs fehlgeschlagenen Datensätze.',
    [SyncRunsTabTestIds.colSyncRecordExternalId]:
      'Externer Bezeichner des Datensatzes im Quellsystem.',
    [SyncRunsTabTestIds.colSyncRecordEntityType]:
      'Entitätstyp des Quelldatensatzes (Identität, Konto, Gruppe, ...).',
    [SyncRunsTabTestIds.colSyncRecordAction]:
      'Aktion am Quelldatensatz während der Synchronisation (erstellt, aktualisiert, gelöscht, übersprungen).',
    [SyncRunsTabTestIds.colSyncRecordCorrelatedIdentity]:
      'Identität, die durch die Korrelationsregeln dem Quelldatensatz zugeordnet wurde.',
    [SyncRunsTabTestIds.colSyncRecordProcessedAt]:
      'Zeitpunkt der Verarbeitung des Datensatzes während des Synchronisationslaufs.',
    [SyncRunsTabTestIds.colSyncRecordErrorMessage]:
      'Fehlermeldung, die erfasst wurde, als der Datensatz nicht verarbeitet werden konnte.',
    [SyncRunsTabTestIds.colSyncRecordPayload]:
      'Zeile umschalten, um die erfasste Staging-Payload anzuzeigen (wird nach erfolgreicher Verarbeitung gelöscht).',
  },
}
